/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SecondShorthand = 'Website.TimeDefinition.SecondShorthand';
export const SecondSingular = 'Website.TimeDefinition.SecondSingular';
export const SecondPlural = 'Website.TimeDefinition.SecondPlural';
export const MinuteShorthand = 'Website.TimeDefinition.MinuteShorthand';
export const MinuteSingular = 'Website.TimeDefinition.MinuteSingular';
export const MinutePlural = 'Website.TimeDefinition.MinutePlural';
export const HourShorthand = 'Website.TimeDefinition.HourShorthand';
export const HourSingular = 'Website.TimeDefinition.HourSingular';
export const HourPlural = 'Website.TimeDefinition.HourPlural';
export const DayShorthand = 'Website.TimeDefinition.DayShorthand';
export const DaySingular = 'Website.TimeDefinition.DaySingular';
export const DayPlural = 'Website.TimeDefinition.DayPlural';
